<template>
    <div class="gift-prompt-modal" v-if="visible">
        <div class="modal-overlay" @click="handleClose"></div>
        <div class="modal-content">
            <!-- 弹窗标题 -->
            <div class="modal-header">
                <h3 class="modal-title">发送礼物</h3>
            </div>

            <!-- 弹窗内容 -->
            <div class="modal-body">
                <div class="gift-icon flex center">
                    <img src="@/assets/theGift.png" alt="礼物" />
                </div>
                <p class="prompt-text">您可以选择一个礼物发送给 {{ user.name }}</p>
                <p class="sub-text">发送礼物可以增进你们的关系</p>
            </div>

            <!-- 弹窗按钮 -->
            <div class="modal-footer">
                <button class="cancel-btn" @click="handleClose">稍后再说</button>
                <button class="confirm-btn" @click="handleConfirm">选择礼物</button>
            </div>

            <!-- 关闭按钮 -->
            <div class="close-btn" @click="handleClose">
                <img src="@/assets/close.png" alt="关闭" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GiftPromptModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        handleClose() {
            this.$emit('close')
        },
        handleConfirm() {
            this.$emit('confirm')
        }
    }
}
</script>

<style scoped>
.gift-prompt-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
    position: relative;
    background: white;
    border-radius: 12px;
    padding: 30px;
    width: 400px;
    max-width: 90vw;
    text-align: center;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
    margin-bottom: 20px;
}

.modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.modal-body {
    margin-bottom: 30px;
}

.gift-icon {
    margin-bottom: 20px;
}

.gift-icon img {
    width: 60px;
    height: 60px;
}

.prompt-text {
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
    line-height: 1.5;
}

.sub-text {
    font-size: 14px;
    color: #666;
    margin: 0;
}

.modal-footer {
    display: flex;
    gap: 15px;
    justify-content: center;
}

.cancel-btn,
.confirm-btn {
    padding: 12px 24px;
    border-radius: 6px;
    border: none;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.cancel-btn {
    background-color: #f5f5f5;
    color: #666;
}

.cancel-btn:hover {
    background-color: #e8e8e8;
}

.confirm-btn {
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    color: white;
}

.confirm-btn:hover {
    background-color: #ff5252;
}

.close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    padding: 5px;
}

.close-btn img {
    width: 20px;
    height: 20px;
    opacity: 0.6;
}

.close-btn:hover img {
    opacity: 1;
}
</style>
